// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollable-canvas_vertical-scrollbar_OSmJW,
.scrollable-canvas_horizontal-scrollbar_dk9jL {
  background: rgba(190, 190, 190, 0.8);
  border-radius: calc(8px / 2);
  width: 100%;
  height: 100%;
}
.scrollable-canvas_vertical-scrollbar-wrapper_FrBv1 {
  position: absolute;
  width: calc(8px + 4px);
  right: 0;
  top: 4px;
  height: calc(100% - 8px - 2 * 4px);
}
.scrollable-canvas_horizontal-scrollbar-wrapper_KI0aj {
  position: absolute;
  height: calc(8px + 4px);
  left: 4px;
  bottom: 0;
  width: calc(100% - 8px - 2 * 4px);
}
.scrollable-canvas_vertical-scrollbar-hitbox_NtC7Z,
.scrollable-canvas_horizontal-scrollbar-hitbox_Ugx8w {
  position: absolute;
  cursor: pointer;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
.scrollable-canvas_vertical-scrollbar-hitbox_NtC7Z {
  width: calc(8px + 4px);
  padding-right: 4px;
}
.scrollable-canvas_horizontal-scrollbar-hitbox_Ugx8w {
  height: calc(8px + 4px);
  padding-bottom: 4px;
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/components/scrollable-canvas/scrollable-canvas.css"],"names":[],"mappings":"AAAA;;EAEE,oCAAoC;EACpC,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,QAAQ;EACR,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,SAAS;EACT,iCAAiC;AACnC;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,8BAA8B;UACtB,sBAAsB;AAChC;AACA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".vertical-scrollbar,\n.horizontal-scrollbar {\n  background: rgba(190, 190, 190, 0.8);\n  border-radius: calc(8px / 2);\n  width: 100%;\n  height: 100%;\n}\n.vertical-scrollbar-wrapper {\n  position: absolute;\n  width: calc(8px + 4px);\n  right: 0;\n  top: 4px;\n  height: calc(100% - 8px - 2 * 4px);\n}\n.horizontal-scrollbar-wrapper {\n  position: absolute;\n  height: calc(8px + 4px);\n  left: 4px;\n  bottom: 0;\n  width: calc(100% - 8px - 2 * 4px);\n}\n.vertical-scrollbar-hitbox,\n.horizontal-scrollbar-hitbox {\n  position: absolute;\n  cursor: pointer;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.vertical-scrollbar-hitbox {\n  width: calc(8px + 4px);\n  padding-right: 4px;\n}\n.horizontal-scrollbar-hitbox {\n  height: calc(8px + 4px);\n  padding-bottom: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vertical-scrollbar": `scrollable-canvas_vertical-scrollbar_OSmJW`,
	"verticalScrollbar": `scrollable-canvas_vertical-scrollbar_OSmJW`,
	"horizontal-scrollbar": `scrollable-canvas_horizontal-scrollbar_dk9jL`,
	"horizontalScrollbar": `scrollable-canvas_horizontal-scrollbar_dk9jL`,
	"vertical-scrollbar-wrapper": `scrollable-canvas_vertical-scrollbar-wrapper_FrBv1`,
	"verticalScrollbarWrapper": `scrollable-canvas_vertical-scrollbar-wrapper_FrBv1`,
	"horizontal-scrollbar-wrapper": `scrollable-canvas_horizontal-scrollbar-wrapper_KI0aj`,
	"horizontalScrollbarWrapper": `scrollable-canvas_horizontal-scrollbar-wrapper_KI0aj`,
	"vertical-scrollbar-hitbox": `scrollable-canvas_vertical-scrollbar-hitbox_NtC7Z`,
	"verticalScrollbarHitbox": `scrollable-canvas_vertical-scrollbar-hitbox_NtC7Z`,
	"horizontal-scrollbar-hitbox": `scrollable-canvas_horizontal-scrollbar-hitbox_Ugx8w`,
	"horizontalScrollbarHitbox": `scrollable-canvas_horizontal-scrollbar-hitbox_Ugx8w`
};
export default ___CSS_LOADER_EXPORT___;
